var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _g3, _g4, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8962 22.4017C12.6306 22.4017 13.2259 21.8063 13.2259 21.0719C13.2259 20.3375 12.6306 19.7422 11.8962 19.7422C11.1618 19.7422 10.5664 20.3375 10.5664 21.0719C10.5664 21.8063 11.1618 22.4017 11.8962 22.4017Z",
    fill: "url(#paint0_radial_8939_69725)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5311 16.625H10.3203C9.80255 16.625 9.38281 17.0447 9.38281 17.5625V20.7267C9.38281 21.2445 9.80255 21.6642 10.3203 21.6642H13.5311C14.0488 21.6642 14.4686 21.2445 14.4686 20.7267V17.5625C14.4686 17.0447 14.0488 16.625 13.5311 16.625Z",
    fill: "url(#paint1_linear_8939_69725)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5311 16.625H10.3203C9.80255 16.625 9.38281 17.0447 9.38281 17.5625V20.7267C9.38281 21.2445 9.80255 21.6642 10.3203 21.6642H13.5311C14.0488 21.6642 14.4686 21.2445 14.4686 20.7267V17.5625C14.4686 17.0447 14.0488 16.625 13.5311 16.625Z",
    fill: "url(#paint2_linear_8939_69725)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5311 16.625H10.3203C9.80255 16.625 9.38281 17.0447 9.38281 17.5625V20.7267C9.38281 21.2445 9.80255 21.6642 10.3203 21.6642H13.5311C14.0488 21.6642 14.4686 21.2445 14.4686 20.7267V17.5625C14.4686 17.0447 14.0488 16.625 13.5311 16.625Z",
    fill: "url(#paint3_radial_8939_69725)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5311 16.625H10.3203C9.80255 16.625 9.38281 17.0447 9.38281 17.5625V20.7267C9.38281 21.2445 9.80255 21.6642 10.3203 21.6642H13.5311C14.0488 21.6642 14.4686 21.2445 14.4686 20.7267V17.5625C14.4686 17.0447 14.0488 16.625 13.5311 16.625Z",
    fill: "url(#paint4_linear_8939_69725)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8939_69725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8196 17.2244H11.8601C12.2771 17.2221 13.2356 17.2064 13.6203 17.1366C14.0328 17.0616 14.0861 16.8554 14.1596 16.5329C14.6111 14.5424 15.3686 13.7774 15.8756 13.2659C15.9536 13.1871 16.0256 13.1136 16.0901 13.0439C16.3098 12.8024 16.5003 12.5894 16.6451 12.4251C17.5115 11.5051 18.0904 10.3521 18.3104 9.10757C18.5305 7.86309 18.3822 6.58144 17.8837 5.4201C17.3853 4.25876 16.5584 3.26833 15.5048 2.57053C14.4511 1.87273 13.2165 1.49795 11.9527 1.49225C10.689 1.48656 9.45106 1.85019 8.39114 2.53846C7.33122 3.22673 6.49547 4.20966 5.98658 5.36646C5.47769 6.52326 5.31784 7.80353 5.52667 9.04994C5.73549 10.2964 6.30391 11.4546 7.16205 12.3824C7.31205 12.5519 7.51605 12.7806 7.75605 13.0439C7.82534 13.12 7.89687 13.194 7.97055 13.2659C8.4768 13.7774 9.23505 14.5431 9.68655 16.5329C9.76005 16.8554 9.8133 17.0616 10.2258 17.1366C10.6091 17.2064 11.3853 17.2221 11.7783 17.2236L11.8196 17.2244Z",
    fill: "url(#paint5_radial_8939_69725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8196 17.2244H11.8601C12.2771 17.2221 13.2356 17.2064 13.6203 17.1366C14.0328 17.0616 14.0861 16.8554 14.1596 16.5329C14.6111 14.5424 15.3686 13.7774 15.8756 13.2659C15.9536 13.1871 16.0256 13.1136 16.0901 13.0439C16.3098 12.8024 16.5003 12.5894 16.6451 12.4251C17.5115 11.5051 18.0904 10.3521 18.3104 9.10757C18.5305 7.86309 18.3822 6.58144 17.8837 5.4201C17.3853 4.25876 16.5584 3.26833 15.5048 2.57053C14.4511 1.87273 13.2165 1.49795 11.9527 1.49225C10.689 1.48656 9.45106 1.85019 8.39114 2.53846C7.33122 3.22673 6.49547 4.20966 5.98658 5.36646C5.47769 6.52326 5.31784 7.80353 5.52667 9.04994C5.73549 10.2964 6.30391 11.4546 7.16205 12.3824C7.31205 12.5519 7.51605 12.7806 7.75605 13.0439C7.82534 13.12 7.89687 13.194 7.97055 13.2659C8.4768 13.7774 9.23505 14.5431 9.68655 16.5329C9.76005 16.8554 9.8133 17.0616 10.2258 17.1366C10.6091 17.2064 11.3853 17.2221 11.7783 17.2236L11.8196 17.2244Z",
    fill: "url(#paint6_radial_8939_69725)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0897 7.71075C14.4683 7.71075 15.5858 6.59325 15.5858 5.21475C15.5858 3.83625 14.4683 2.71875 13.0897 2.71875C11.7112 2.71875 10.5938 3.83625 10.5938 5.21475C10.5938 6.59325 11.7112 7.71075 13.0897 7.71075Z",
    fill: "url(#paint7_linear_8939_69725)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8939_69725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6025 17.2242C11.5763 15.5952 11.4465 14.5227 11.2485 13.7757C11.0213 12.9155 10.7025 12.4857 10.365 12.146L10.3613 12.1415L10.3568 12.1377C10.0313 11.8299 9.80575 11.4315 9.70921 10.9941C9.61268 10.5567 9.64963 10.1004 9.81527 9.68421C9.98092 9.26802 10.2676 8.91112 10.6383 8.65967C11.0091 8.40823 11.4467 8.27381 11.8946 8.27381C12.3426 8.27381 12.7802 8.40823 13.1509 8.65967C13.5216 8.91112 13.8083 9.26802 13.974 9.68421C14.1396 10.1004 14.1766 10.5567 14.08 10.9941C13.9835 11.4315 13.7579 11.8299 13.4325 12.1377L13.428 12.1415L13.4235 12.146C13.0928 12.4805 12.7695 12.881 12.5393 13.7345C12.3398 14.4732 12.2093 15.5495 12.183 17.2227C12.4095 17.219 12.6803 17.2122 12.9338 17.2002C12.9608 15.5742 13.0883 14.5782 13.2638 13.9302C13.4528 13.2275 13.6965 12.9365 13.9523 12.6777C14.3854 12.2662 14.6853 11.7342 14.8131 11.1506C14.9409 10.5669 14.8908 9.95834 14.6692 9.40345C14.4477 8.84855 14.0648 8.37282 13.5702 8.03769C13.0755 7.70257 12.4917 7.52344 11.8943 7.52344C11.2968 7.52344 10.713 7.70257 10.2183 8.03769C9.72366 8.37282 9.34083 8.84855 9.11927 9.40345C8.89772 9.95834 8.8476 10.5669 8.97541 11.1506C9.10322 11.7342 9.40307 12.2662 9.83625 12.6777C10.086 12.9305 10.3328 13.2462 10.524 13.9677C10.698 14.627 10.824 15.6207 10.8518 17.2002C11.112 17.2152 11.3858 17.2212 11.6018 17.2242",
    fill: "#FFAD55"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8939_69725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6551 17.0513C12.6551 13.473 13.2033 12.9015 13.7913 12.3083C14.1713 11.9489 14.4347 11.4838 14.5474 10.9731C14.6601 10.4624 14.617 9.92957 14.4236 9.44364C14.2302 8.95771 13.8954 8.54099 13.4626 8.24741C13.0298 7.95382 12.5188 7.79688 11.9958 7.79688C11.4728 7.79688 10.9618 7.95382 10.529 8.24741C10.0962 8.54099 9.76142 8.95771 9.56803 9.44364C9.37463 9.92957 9.3315 10.4624 9.44423 10.9731C9.55695 11.4838 9.82034 11.9489 10.2003 12.3083C10.7883 12.9015 11.3336 13.929 11.3336 17.0513",
    stroke: "url(#paint8_linear_8939_69725)",
    strokeWidth: 0.1875
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8939_69725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9706 18.1151L9.71673 18.7816C9.49779 18.8159 9.34812 19.0212 9.38242 19.2402C9.41673 19.4591 9.62202 19.6088 9.84095 19.5745L14.0948 18.908C14.3137 18.8736 14.4634 18.6684 14.4291 18.4494C14.3948 18.2305 14.1895 18.0808 13.9706 18.1151Z",
    fill: "#7E6693"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8939_69725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9706 19.8886L9.71673 20.5551C9.49779 20.5894 9.34812 20.7947 9.38242 21.0136C9.41673 21.2325 9.62202 21.3822 9.84095 21.3479L14.0948 20.6814C14.3137 20.6471 14.4634 20.4418 14.4291 20.2229C14.3948 20.0039 14.1895 19.8543 13.9706 19.8886Z",
    fill: "#7E6693"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 19.6918L9.16608 20.5298C8.9406 20.5651 8.78645 20.7765 8.82178 21.002C8.85711 21.2275 9.06854 21.3816 9.29402 21.3463L14.6423 20.5083C14.8677 20.473 15.0219 20.2616 14.9866 20.0361C14.9512 19.8106 14.7398 19.6565 14.5143 19.6918Z",
    fill: "url(#paint9_linear_8939_69725)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 19.6918L9.16608 20.5298C8.9406 20.5651 8.78645 20.7765 8.82178 21.002C8.85711 21.2275 9.06854 21.3816 9.29402 21.3463L14.6423 20.5083C14.8677 20.473 15.0219 20.2616 14.9866 20.0361C14.9512 19.8106 14.7398 19.6565 14.5143 19.6918Z",
    fill: "url(#paint10_linear_8939_69725)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 19.6918L9.16608 20.5298C8.9406 20.5651 8.78645 20.7765 8.82178 21.002C8.85711 21.2275 9.06854 21.3816 9.29402 21.3463L14.6423 20.5083C14.8677 20.473 15.0219 20.2616 14.9866 20.0361C14.9512 19.8106 14.7398 19.6565 14.5143 19.6918Z",
    fill: "url(#paint11_linear_8939_69725)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 19.6918L9.16608 20.5298C8.9406 20.5651 8.78645 20.7765 8.82178 21.002C8.85711 21.2275 9.06854 21.3816 9.29402 21.3463L14.6423 20.5083C14.8677 20.473 15.0219 20.2616 14.9866 20.0361C14.9512 19.8106 14.7398 19.6565 14.5143 19.6918Z",
    fill: "url(#paint12_radial_8939_69725)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 17.9105L9.16608 18.7485C8.9406 18.7839 8.78645 18.9953 8.82178 19.2208C8.85711 19.4462 9.06854 19.6004 9.29402 19.5651L14.6423 18.7271C14.8677 18.6917 15.0219 18.4803 14.9866 18.2548C14.9512 18.0294 14.7398 17.8752 14.5143 17.9105Z",
    fill: "url(#paint13_linear_8939_69725)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 17.9105L9.16608 18.7485C8.9406 18.7839 8.78645 18.9953 8.82178 19.2208C8.85711 19.4462 9.06854 19.6004 9.29402 19.5651L14.6423 18.7271C14.8677 18.6917 15.0219 18.4803 14.9866 18.2548C14.9512 18.0294 14.7398 17.8752 14.5143 17.9105Z",
    fill: "url(#paint14_linear_8939_69725)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 17.9105L9.16608 18.7485C8.9406 18.7839 8.78645 18.9953 8.82178 19.2208C8.85711 19.4462 9.06854 19.6004 9.29402 19.5651L14.6423 18.7271C14.8677 18.6917 15.0219 18.4803 14.9866 18.2548C14.9512 18.0294 14.7398 17.8752 14.5143 17.9105Z",
    fill: "url(#paint15_linear_8939_69725)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5143 17.9105L9.16608 18.7485C8.9406 18.7839 8.78645 18.9953 8.82178 19.2208C8.85711 19.4462 9.06854 19.6004 9.29402 19.5651L14.6423 18.7271C14.8677 18.6917 15.0219 18.4803 14.9866 18.2548C14.9512 18.0294 14.7398 17.8752 14.5143 17.9105Z",
    fill: "url(#paint16_radial_8939_69725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8939_69725",
    x: 5.4375,
    y: 1.49219,
    width: 13.1602,
    height: 15.8469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: 0.1125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.666667 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8939_69725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8939_69725",
    x: 8.90625,
    y: 7.52344,
    width: 6.16406,
    height: 9.70312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.572549 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8939_69725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8939_69725",
    x: 9.10156,
    y: 7.51562,
    width: 5.78906,
    height: 9.72656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09375,
    result: "effect1_foregroundBlur_8939_69725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8939_69725",
    x: 9.19141,
    y: 17.9219,
    width: 5.42969,
    height: 1.84375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09375,
    result: "effect1_foregroundBlur_8939_69725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8939_69725",
    x: 9.19141,
    y: 19.6953,
    width: 5.42969,
    height: 1.84375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09375,
    result: "effect1_foregroundBlur_8939_69725"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2479 21.8279) rotate(96.6541) scale(0.707893 1.6396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#AC90C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8939_69725",
    x1: 14.4686,
    y1: 19.3475,
    x2: 9.38281,
    y2: 19.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8939_69725",
    x1: 9.13156,
    y1: 19.7307,
    x2: 10.3736,
    y2: 19.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7B88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9746 16.976) rotate(88.6357) scale(0.618655 2.75432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#EDE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BCCB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8939_69725",
    x1: 13.0923,
    y1: 21.6642,
    x2: 13.0923,
    y2: 20.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5F9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6613 6.09219) rotate(138.066) scale(7.43527 6.13105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#FFEC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3641 10.0761) rotate(-147.604) scale(10.9364 10.5193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FFB239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8939_69725",
    x1: 12.2168,
    y1: 6.02025,
    x2: 14.7833,
    y2: 4.02075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8939_69725",
    x1: 14.7858,
    y1: 8.24478,
    x2: 11.7813,
    y2: 15.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8939_69725",
    x1: 11.7664,
    y1: 20.1292,
    x2: 11.966,
    y2: 21.0203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8939_69725",
    x1: 12.6101,
    y1: 20.8093,
    x2: 12.5168,
    y2: 20.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8939_69725",
    x1: 8.75753,
    y1: 21.0667,
    x2: 10.8054,
    y2: 20.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9105 20.0726) rotate(81.4165) scale(0.628136 3.71783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8939_69725",
    x1: 11.7665,
    y1: 18.3487,
    x2: 11.966,
    y2: 19.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8939_69725",
    x1: 12.6101,
    y1: 19.028,
    x2: 12.5168,
    y2: 18.4422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8939_69725",
    x1: 8.75764,
    y1: 19.2862,
    x2: 10.8054,
    y2: 18.8523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_8939_69725",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9105 18.2913) rotate(81.4165) scale(0.628134 3.71782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.f9aa10f5b21bb48c9b61adf03c86e59d.svg";
export { ForwardRef as ReactComponent };